import { trpc } from '@tencent/tpro_rmonitor_login_server_login_auth';
import { logout, logoutByHistory } from '@/infrastructure/logout';
import { reporter } from '@/infrastructure/reporter/datong';
import { redirectToPrevPage } from '@/presentation/hooks/user/utils';
import { getCookie, WithTypeCast } from '@raft/utils';
import { BaseUser } from './base-user';
import { AuthUser, ProUserInfo } from './types';
import { LoginType, Token } from './utils';
type IUserInfo = WithTypeCast<trpc.rmonitor.login_server.IUserInfo>;

const noNeedCheckLoginList = [
  '/login',
  '/register',
  '/select-account',
  '/security',
];

export default class WoaUser implements BaseUser<ProUserInfo> {
  onLogin(
    _loginType: LoginType,
    userInfo: IUserInfo,
    _token?: Token,
  ): boolean {
    // 登录完成后设置上报用户
    reporter?.setPublicParams({
      username: userInfo.buglyUserName,
      userId: userInfo.buglyUserId,
    });
    redirectToPrevPage();
    return true;
  }
  logout(): void {
    logout();
  }
  checkLogin(pathname: string, history: any): boolean {
    const authInfo = this.initUserInfo();
    const noNeedCheck = noNeedCheckLoginList.includes(pathname);
    // 检查登录态
    if (!noNeedCheck && !authInfo.isLoggedIn) {
      logoutByHistory(history);
      return false;
    }

    return true;
  }
  getUserInfo(): ProUserInfo {
    return {
      buglyId: this.getUserId(),
      name: this.getUserName(),
    };
  }

  // todo 类型处理
  initUserInfo(): AuthUser {
    return {
      // 过了智能网关，所以肯定登录了
      isLoggedIn: true,
      userInfo: {
        buglyId: this.getUserId(),
        name: this.getUserName(),
      },
    };
  }
  getAvatar(): string {
    const userName = this.getUserName();
    return userName ? `https://r.hrc.woa.com/photo/100/${userName}.png` : '';
  }
  /**
   * WOA版本id和userName是一样的
   * @returns
   */
  public getUserName(): string {
    return this.getUserId();
  }

  public getUserId() {
    let staffName = getCookie('buglyUserName') || '';
    staffName = staffName.replace(/"/g, '');
    return decodeURIComponent(staffName);
  }
}
